import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api, resolveFileUrl } from "@/lib/api";

export default function Pengumuman() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 sm:p-10 max-w-2xl" data-testid="member-pengumuman-page">
      <h1 className="font-display text-xl font-bold text-piks-black mb-6">Pengumuman</h1>
      {loading ? (
        <p className="text-piks-muted text-sm">Memuatkan...</p>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-piks-muted" data-testid="pengumuman-empty-state">
          <Megaphone className="w-10 h-10 mx-auto mb-3 opacity-40" />
          Tiada pengumuman tersedia.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((a) => (
            <div key={a.id} className="rounded-lg bg-white border border-piks-border overflow-hidden" data-testid={`member-announcement-${a.id}`}>
              {a.image_url && (
                <div className="w-full h-40 overflow-hidden">
                  <img src={resolveFileUrl(a.image_url)} alt={a.title} className="w-full h-full object-cover" data-testid={`member-announcement-image-${a.id}`} />
                </div>
              )}
              <div className="p-5">
                <p className="text-xs text-piks-muted mb-1.5">{new Date(a.published_at).toLocaleDateString("ms-MY")}</p>
                <p className="font-semibold text-piks-black mb-1">{a.title}</p>
                <p className="text-sm text-piks-muted leading-relaxed">{a.body}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
